import { Box, Link as MuiLink } from '@mui/material';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BASE_API_URL, DEFAULT_LANGUAGE, PATHS, ROUTES } from 'src/constants';
import { useImpacts, useLogout, useMe, useProductJourney } from 'src/hooks';
import { convertToBase64Url, stripEnding, join } from 'src/utils';

export const FooterNav = () => {
  const [t, i18n] = useTranslation();
  const location = useLocation();

  const { simpleProductId } = useParams();
  const { isImpacts, product } = useImpacts();
  const { data: journey, isLoading: isJourneyLoading } = useProductJourney(
    (product as any)?.id,
    i18n.language,
    simpleProductId
  );
  const { data: me, isLoading: isMeLoading } = useMe();
  const logout = useLogout();

  const hasJourney = !isJourneyLoading && Boolean(journey?.product?.journey?.steps?.length);
  const canRegister = Boolean(product?.settings?.sign_up_enabled);
  const canShowAbout = Boolean(product?.account_id);

  const accountPath =
  i18n.language === DEFAULT_LANGUAGE ?
  `/${ROUTES.ACCOUNT}/${product?.account_simple_id}` :
  `/${i18n.language}/${ROUTES.ACCOUNT}/${product?.account_simple_id}`;

  const from = convertToBase64Url(
    window.location.origin +
    window.location.pathname + (
    product?.account_id ? `&account_id=${product?.account_id}` : '')
  );

  const stateFrom = { from: location.pathname };

  const baseForDeepLinks = [PATHS.JOURNEY, PATHS.IMPACTS].reduce(
    (p, seg) => stripEnding(p, seg),
    location.pathname
  );

  const journeyTo = join(baseForDeepLinks, ROUTES.JOURNEY);
  const impactsTo = join(baseForDeepLinks, ROUTES.IMPACTS);

  const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    await logout();
    window.location.reload();
  };

  return (
    <Box id="nav-menu__components-page-simple-footer__box__l54"
    display="flex"
    flexWrap="wrap"
    justifyContent="center"
    alignItems="center"
    columnGap={{ xs: 1.5, sm: 2, md: 3 }}
    rowGap={1}
    px={'20px'}
    py={0.5}>
      
      <MuiLink id="nav-menu__components-page-simple-footer__muilink__l64"
      component={RouterLink}
      to="/"
      state={stateFrom}
      underline="hover"
      color="text.secondary"
      sx={{ fontWeight: 500, fontSize: '14px' }}
      // srate={{ from: location.pathname }}
      >
        {t('home-header-title')}
      </MuiLink>

      {hasJourney &&
      <MuiLink id="nav-menu__components-page-simple-footer__muilink__l77"
      component={RouterLink}
      to={journeyTo}
      state={stateFrom}
      underline="hover"
      color="text.secondary"
      sx={{ fontWeight: 500, fontSize: '14px' }}>
        
          {t('journey-header-title')}
        </MuiLink>
      }

      {isImpacts &&
      <MuiLink id="nav-menu__components-page-simple-footer__muilink__l90"
      component={RouterLink}
      to={impactsTo}
      state={stateFrom}
      underline="hover"
      color="text.secondary"
      sx={{ fontWeight: 500, fontSize: '14px' }}>
        
          {t('impacts-header-title')}
        </MuiLink>
      }

      {canShowAbout &&
      <MuiLink id="nav-menu__components-page-simple-footer__muilink__l103"
      component={RouterLink}
      to={accountPath}
      state={{ ...stateFrom, productId: simpleProductId }}
      underline="hover"
      color="text.secondary"
      sx={{ fontWeight: 500, fontSize: '14px' }}>
        
          {t('account-header-title')}
        </MuiLink>
      }

      {!isMeLoading && me &&
      <MuiLink id="nav-menu__components-page-simple-footer__muilink__l116"
      href="#"
      onClick={handleLogout}
      underline="hover"
      color="text.secondary"
      sx={{ fontWeight: 500, fontSize: '14px' }}>
        
          {t('log-out-button-text')}
        </MuiLink>
      }

      {!isMeLoading && !me &&
      <>
          <MuiLink id="nav-menu__components-page-simple-footer__muilink__l129"
        href={`${BASE_API_URL}auth/journey/sign-in/${from}`}
        underline="hover"
        color="text.secondary"
        sx={{ fontWeight: 500, fontSize: '14px' }}>
          
            {t('log-in-button-text')}
          </MuiLink>
          {canRegister &&
        <MuiLink id="nav-menu__components-page-simple-footer__muilink__l138"
        href={`${BASE_API_URL}auth/journey/register/${from}`}
        underline="hover"
        color="text.secondary">
          
              {t('sign-up-button-text')}
            </MuiLink>
        }
        </>
      }
    </Box>);

};